<template>
  <div>
    <van-tabs style="width: 100%;height: 100%" color="#1875f8" line-width="15px" line-height="3px"
              title-active-color="#1875f8"
              offset-top="45px" duration="0.5" v-model="active" animated sticky swipeable lazy-render
              v-if="newsList.data">
      <van-tab v-for="(data,index) in newsList.data"
               :title="data.name">


        <div class="mainBody">
          <div v-for="(dataSon,indexSon) in newsList.data" v-if="active === index && index === indexSon"
               :key="indexSon">
            <van-pull-refresh v-model="refreshing[index]" @refresh="onRefresh(data,index)">
              <van-list v-model="loading[index]" :finished="finished[index]" finished-text="没有更多了"
                        @load="onLoad(data,index)">


                <div v-for="(item,indexSS) in list[index]">
                  <div class="newsDate">
                    <div
                        v-if="!(indexSS === 0?$dateCheckNF(item.release_time,''):$dateCheckNF(item.release_time,list[index][indexSS - 1].release_time))">
                      <div class="lilRound"></div>
                      <div class="bigRound"></div>
                    </div>

                    <div class="MD"
                         v-if="indexSS === 0?$dateCheckNF(item.release_time,''):$dateCheckNF(item.release_time,list[index][indexSS - 1].release_time)">
                      <div class="MDTop">
                        <div>{{ $dateMDNF(item.release_time).month }}月</div>
                      </div>
                      <div class="day">{{ $dateMDNF(item.release_time).day }}</div>
                    </div>


                    <div class="hLine"></div>
                    <div :class="indexSS === 0?'vLineHalf':'vLine'"></div>
                    <div class="dateBox">{{ $dateChangeNF(item.release_time) }}</div>
                  </div>

                  <div class="textBox">
                    <div class="vLine"></div>
                    <div class="text">{{ item.title }}</div>

                  </div>


                </div>


              </van-list>
            </van-pull-refresh>
          </div>


        </div>


      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "newsFlashList",
  data() {
    return {
      active: 0,
      newsList: {},
      newsQuery: [],
      newsEn: [],
      newsRes: [],
      list: [],
      loading: [],
      finished: [],
      refreshing: [],
    }
  },
  methods: {
    getNewsList() {
      this.$get(this.$store.state.apiUrl + '/information/newFlashNav', {qdata: this.$encrypt(this.$genQuery({}))}).then(res => {
        this.newsList = res
        for (let i = 0; i < this.newsList.data.length; i++) {
          this.list[i] = []
          this.loading[i] = false;
          this.finished[i] = false;
          this.refreshing[i] = false;
          this.newsRes[i] = {};
          this.newsQuery[i] = {
            page_size: 10,
            new_flash_type: this.newsList.data[i].type_id,
            last_id: 0
          }
        }


      }).catch(err => {
        console.log(err)
      })
    },
    onLoad(data, index) {
      if (this.refreshing[index]) {
        this.newsRes[index] = {data: {list: []}}
        this.refreshing[index] = false;
      }
      this.newsEn[index] = this.$encrypt(this.$genQuery(this.newsQuery[index]))
      this.$get(this.$store.state.apiUrl + "/information/newFlash", {qdata: this.newsEn[index]}).then(res => {
        this.$forceUpdate();
        this.newsRes[index] = res;
        for (let i = 0; i < this.newsRes[index].data.list.length; i++) {
          this.list[index].push(this.newsRes[index].data.list[i]);
        }
        this.loading[index] = false;
        this.newsQuery[index].last_id = this.newsRes[index].data.list[this.newsRes[index].data.list.length - 1].id;
        if (this.newsRes[index].data.list.length === 0 || this.newsRes[index].data.list.length % 10 !== 0) {
          this.finished[index] = true;
        }

      }).catch(err => {
        console.log(err)
      })

    },
    onRefresh(data, index) {

      // 清空列表数据
      this.finished[index] = false;
      this.list[index] = [];
      this.newsQuery[index].last_id = 0;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading[index] = true;
      this.onLoad(data, index);
    },

  },
  mounted() {
    this.getNewsList()
  }
}
</script>

<style scoped>
.mainBody {
  margin: 0 16px;
  padding-top: 46px;
}


</style>
